import { render, staticRenderFns } from "./ApplicantEdit.vue?vue&type=template&id=38132836&scoped=true&"
import script from "./ApplicantEdit.vue?vue&type=script&lang=javascript&"
export * from "./ApplicantEdit.vue?vue&type=script&lang=javascript&"
import style0 from "./ApplicantEdit.vue?vue&type=style&index=0&id=38132836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38132836",
  null
  
)

export default component.exports